import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@mui/material'
import { Button } from 'components'
import intl from 'localization/components'
import { useSnackbar } from 'notistack'
import { FormattedMessage, useIntl } from 'react-intl'
import { useUpdateCustomer } from 'services/queries/use-update-customer'

type DeleteZoneProps = {
  zones: any
  deleteData: any
  selectedCustomer: any
  open: boolean
  setOpen: Function
  onSubmit: Function
  title: string
  content: string
}
const DeleteZone = ({
  zones,
  deleteData,
  selectedCustomer,
  open,
  setOpen,
  onSubmit,
  title,
  content,
}: DeleteZoneProps): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar()
  const reactIntl = useIntl()
  const messages = reactIntl.messages

  const handleClose = () => {
    setOpen(false)
  }

  const onSuccess = () => {
    enqueueSnackbar(
      messages[intl.customerZones('customer-zone-delete-success')],
      {
        variant: 'success',
        autoHideDuration: 3000,
      },
    )
    onSubmit()
  }

  const onError = () => {
    enqueueSnackbar(
      messages[intl.customerZones('customer-zone-delete-failed')],
      {
        variant: 'error',
        autoHideDuration: 3000,
      },
    )
    onSubmit()
  }

  const { mutate: updateCustomer, isLoading: isSavingData } = useUpdateCustomer(
    { onSuccess, onError },
  )

  const handleDeleteZoneSubscription = () => {
    const newZones = zones.filter((zone) => zone.name !== deleteData.name)
    const newAllowZones = newZones.reduce((acc, zone) => {
      acc[zone.name] = zone.countries
      return acc
    }, {})
    const newGlobalLookupLimits = newZones.reduce((acc, zone) => {
      acc[zone.name] = zone.allocation
      return acc
    }, {})

    const newData = {
      allow_zones:
        Object.keys(newAllowZones).length > 0 ? { ...newAllowZones } : null,
      global_lookups_limit:
        Object.keys(newGlobalLookupLimits).length > 0
          ? { ...newGlobalLookupLimits }
          : null,
    }

    updateCustomer({
      companyId: selectedCustomer,
      reqBody: {
        data: { ...newData },
      },
    })
  }

  const handleCloseDialog = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleCloseDialog} disableEscapeKeyDown>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSavingData}>
          {<FormattedMessage id={intl.confirmAction('cancel')} />}
        </Button>
        <Button
          onClick={handleDeleteZoneSubscription}
          color="primary"
          autoFocus
          disabled={isSavingData}
        >
          {isSavingData ? (
            <CircularProgress size={24} />
          ) : (
            <FormattedMessage id={intl.confirmAction('agree')} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteZone
